/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";

/*import url and gateway methods */
import { deleteData, getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import time calculation
import { calculateEndTime, getCurrentTime } from "helper/TimeCalculation";
import { getDuration } from "helper/EventHelper/EventHelper";
import { useTranslation } from "react-i18next";

const SaveAgendaModal = ({
  onModalClose,
  setSelectedAgendaId,
  selectedAgendaId,
  setIsDateSpecific,
  isDateSpecific,
  selectedCalendarAgendaDate,
  setSelectedCalendarAgendaDate,
}) => {
  const params = useParams();
  const token = localStorage.getItem("token");
  const { t } = useTranslation(); // for translations
  const [agendaTitle, setagendaTitle] = useState("Available");
  const [agendaDate, setagendaDate] = useState("");
  const [startTime, setstartTime] = useState(getCurrentTime());
  const [endTime, setendTime] = useState(getCurrentTime());
  const [location, setLocation] = useState("");
  const [isDateSpecificFromApi, setIsDateSpecificFromApi] = useState(false);

  /* hooks for validation */
  const [validation, setValidation] = useState({
    titleWarning: false,
    dateWarning: false,
    startTimeWarning: false,
    endTimeWarning: false,
    timeDiffWarning: false,
  });

  // validate =========================
  const validate = () => {
    let isValid = true;

    if (agendaTitle === "") {
      setValidation((prevState) => ({ ...prevState, titleWarning: true }));
      isValid = false;
    }

    if (agendaDate == "") {
      setValidation((prevState) => ({ ...prevState, dateWarning: true }));
      isValid = false;
    }

    if (startTime == "") {
      setValidation((prevState) => ({
        ...prevState,
        startTimeWarning: true,
      }));
      isValid = false;
    }

    if (endTime == "") {
      setValidation((prevState) => ({
        ...prevState,
        endTimeWarning: true,
      }));
      isValid = false;
    }

    if (startTime !== "" && endTime !== "") {
      if (startTime > endTime) {
        setValidation((prevState) => ({
          ...prevState,
          timeDiffWarning: true,
        }));
        isValid = false;
      }
    }

    return isValid;
  };

  //get agenda details
  const getAgendaDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_DETAILS_AGENDA +
        `/${selectedAgendaId}?token=${token}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        setagendaTitle(response.data.description);
        setagendaDate(response.data.date);
        setstartTime(response.data.starttime);
        setendTime(response.data.endtime);
        setLocation(response.data.location);
        setIsDateSpecificFromApi(response.data.datespecifichours);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //save agenda
  const saveAgendaHandler = async () => {
    if (validate()) {
      try {
        let agendaData = {
          description: agendaTitle == "" ? "Available" : agendaTitle,
          location: location,
          userid: params.id,
          date: agendaDate,
          starttime: startTime,
          endtime: endTime,
          duration: getDuration(startTime, endTime),
          availability: true,
          datespecifichours: isDateSpecificFromApi
            ? isDateSpecificFromApi
            : isDateSpecific
            ? true
            : false,
          attendants: [],
        };

        console.log("agenda data----->", agendaData);

        let requestUrl = url.API_BASE_URL;

        let response = null;

        if (selectedAgendaId) {
          requestUrl =
            requestUrl +
            url.API_UPDATE_AGENDA +
            `/${selectedAgendaId}?token=${token}`;

          console.log(requestUrl);

          response = await putData(requestUrl, agendaData);

          console.log(response);
        } else {
          requestUrl = requestUrl + url.API_ADD_NEW_AGENDA + `?token=${token}`;

          console.log(requestUrl);

          response = await postData(requestUrl, agendaData);

          console.log(response);
        }

        if (response.status) {
          resetHandler();

          //hide member modal
          let bootstrapModal = document.querySelector("#saveAccountAgenda");
          let modal = bootstrap.Modal.getInstance(bootstrapModal);
          modal.hide();

          onModalClose();
        }
      } catch (error) {
        console.log(error.message);
      }
    } else {
    }
  };

  //delete agenda
  const deleteAgendaHandler = async () => {
    if (selectedAgendaId) {
      try {
        let requestUrl =
          url.API_BASE_URL +
          url.API_DELETE_AGENDA +
          `/${selectedAgendaId}?token=${token}`;

        const response = await deleteData(requestUrl);

        if (response.status) {
          resetHandler();

          //hide member modal
          let bootstrapModal = document.querySelector("#saveAccountAgenda");
          let modal = bootstrap.Modal.getInstance(bootstrapModal);
          modal.hide();

          onModalClose();
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  //reset
  const resetHandler = () => {
    setValidation({
      titleWarning: false,
      dateWarning: false,
      startTimeWarning: false,
      endTimeWarning: false,
    });

    setagendaTitle("Available");
    setagendaDate("");
    setstartTime(getCurrentTime());
    setendTime(getCurrentTime());
    setLocation("");
    setSelectedAgendaId(null);
    setIsDateSpecific(false);
    setSelectedCalendarAgendaDate("");
  };

  useEffect(() => {
    if (selectedAgendaId) {
      getAgendaDetails();
    }
  }, [selectedAgendaId]);

  useEffect(() => {
    if (selectedCalendarAgendaDate != "") {
      setagendaDate(selectedCalendarAgendaDate);
    }
  }, [selectedCalendarAgendaDate]);

  return (
    <div
      className="modal fade"
      id="saveAccountAgenda"
      tabIndex="-1"
      aria-labelledby="saveAccountAgenda"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15 shadow-lg">
          {/* Enhanced Header with Icon and Gradient Background */}
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  event
                </span>
              </div>
              <div>
                <h3
                  className="fw-bold fs-3 text-white mb-0"
                  id="dateSpecificHoursLabel"
                >
                  {isDateSpecific ? t("Date-Specific Hours") : t("Save agenda")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Configure your agenda details")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
          </div>

          {/* Enhanced Modal Body */}
          <div
            className="modal-body p-4"
            style={{ backgroundColor: "var(--bs-gray-200)" }}
          >
            {/* Professional Card Layout */}
            <div className="p-3 p-md-4 border border-gray-300 rounded-15 shadow-sm bg-white">
              <form
                onSubmit={(e) => e.preventDefault()}
                className="d-flex flex-column h-100"
              >
                <div className="form-group d-flex mb-4">
                  <div className="field-group d-flex flex-column gap-3 flex-fill">
                    {/* Information Notice */}
                    <div
                      className="alert alert-primary border-0 rounded-10 mb-4 d-flex align-items-center gap-3"
                      style={{
                        backgroundColor: "rgba(var(--bs-primary-rgb), 0.1)",
                        border: "1px solid rgba(var(--bs-primary-rgb), 0.2)",
                      }}
                    >
                      <div
                        className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          width: "40px",
                          height: "40px",
                          backgroundColor: "var(--bs-primary)",
                        }}
                      >
                        <span className="material-symbols-outlined text-white fs-sm">
                          info
                        </span>
                      </div>
                      <div>
                        <p
                          className="fw-semibold mb-1"
                          style={{ color: "var(--bs-primary)" }}
                        >
                          {t("Time Slot Guidelines")}
                        </p>
                        <p
                          className="fs-sm mb-0"
                          style={{ color: "var(--bs-primary)" }}
                        >
                          ** {t("Each slot should be in 1 hour")}
                        </p>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-2 mb-3">
                      <div
                        className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: "35px", height: "35px" }}
                      >
                        <span className="material-symbols-outlined text-white fs-sm">
                          description
                        </span>
                      </div>
                      <label
                        htmlFor="agendaTitle"
                        className="d-block fs-md fw-bold text-dark mb-0"
                      >
                        {t("Agenda Details")}
                      </label>
                    </div>
                    <div
                      className="field-container p-4 rounded-15 shadow-sm mb-4 position-relative overflow-hidden"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(248, 249, 250, 1) 100%)",
                        border: "1px solid var(--bs-gray-300)",
                        transition: "all 0.3s ease-in-out",
                      }}
                    >
                      <div className="row g-3 mb-2">
                        <div className="col-md-6">
                          <label className="d-block fs-sm fw-bold text-dark mb-0">
                            <span
                              className="material-symbols-outlined fs-sm me-1"
                              style={{ verticalAlign: "middle" }}
                            >
                              description
                            </span>
                            {t("Title")}
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label className="d-block fs-sm fw-bold text-dark mb-0">
                            <span
                              className="material-symbols-outlined fs-sm me-1"
                              style={{ verticalAlign: "middle" }}
                            >
                              event
                            </span>
                            {t("Date")}
                          </label>
                        </div>
                      </div>
                      <div className="row g-3 mb-2">
                        <div className="col-md-6">
                          <input
                            type="text"
                            className={`form-control shadow-none fw-semibold border ${
                              validation.titleWarning
                                ? "border-primary"
                                : "border-gray-300"
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 16px",
                              fontSize: "0.9rem",
                            }}
                            placeholder={t("Enter title")}
                            value={agendaTitle}
                            onChange={(e) => {
                              setagendaTitle(e.target.value);
                              setValidation((prevState) => ({
                                ...prevState,
                                titleWarning: false,
                              }));
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <input
                            type="date"
                            className={`form-control shadow-none fw-semibold border ${
                              validation.dateWarning
                                ? "border-primary"
                                : "border-gray-300"
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 16px",
                              fontSize: "0.9rem",
                            }}
                            placeholder={t("Enter Date")}
                            value={agendaDate}
                            onChange={(e) => {
                              setagendaDate(e.target.value);
                              setValidation((prevState) => ({
                                ...prevState,
                                dateWarning: false,
                              }));
                            }}
                          />
                        </div>
                      </div>
                      {(validation.titleWarning || validation.dateWarning) && (
                        <div className="row g-3 mt-1">
                          <div className="col-md-6">
                            {validation.titleWarning && (
                              <div
                                className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2"
                                style={{
                                  fontSize: "0.75rem",
                                  margin: "0",
                                  width: "max-content",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{ fontSize: "0.9rem" }}
                                >
                                  warning
                                </span>
                                <span>{t("Please enter a title!")}</span>
                              </div>
                            )}
                          </div>
                          <div className="col-md-6">
                            {validation.dateWarning && (
                              <div
                                className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2"
                                style={{
                                  fontSize: "0.75rem",
                                  margin: "0",
                                  width: "max-content",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{ fontSize: "0.9rem" }}
                                >
                                  warning
                                </span>
                                <span>{t("Please enter date!")}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="d-flex align-items-center gap-2 mb-3">
                      <div
                        className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: "35px", height: "35px" }}
                      >
                        <span className="material-symbols-outlined text-white fs-sm">
                          access_time
                        </span>
                      </div>
                      <label
                        htmlFor="timing"
                        className="d-block fs-md fw-bold text-dark mb-0"
                      >
                        {t("Timings")}
                      </label>
                    </div>

                    <div
                      className="field-container p-4 rounded-15 shadow-sm mb-4 position-relative overflow-hidden"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(248, 249, 250, 1) 100%)",
                        border: "1px solid var(--bs-gray-300)",
                        transition: "all 0.3s ease-in-out",
                      }}
                    >
                      <div className="row g-3 mb-2">
                        <div className="col-md-6">
                          <label className="d-block fs-sm fw-bold text-dark mb-0">
                            <span
                              className="material-symbols-outlined fs-sm me-1"
                              style={{ verticalAlign: "middle" }}
                            >
                              play_arrow
                            </span>
                            {t("Start Time")}
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label className="d-block fs-sm fw-bold text-dark mb-0">
                            <span
                              className="material-symbols-outlined fs-sm me-1"
                              style={{ verticalAlign: "middle" }}
                            >
                              stop
                            </span>
                            {t("End Time")}
                          </label>
                        </div>
                      </div>
                      <div className="row g-3 mb-2">
                        <div className="col-md-6">
                          <input
                            type="time"
                            className={`form-control shadow-none fw-semibold border ${
                              validation.startTimeWarning
                                ? "border-primary"
                                : "border-gray-300"
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 16px",
                              fontSize: "0.9rem",
                            }}
                            placeholder={t("Start Time")}
                            value={startTime}
                            onChange={(e) => {
                              setstartTime(e.target.value);
                              setendTime(calculateEndTime(1, e.target.value));
                              setValidation((prevState) => ({
                                ...prevState,
                                startTimeWarning: false,
                                timeDiffWarning: false,
                              }));
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <input
                            type="time"
                            className={`form-control shadow-none fw-semibold border ${
                              validation.endTimeWarning ||
                              validation.timeDiffWarning
                                ? "border-primary"
                                : "border-gray-300"
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 16px",
                              fontSize: "0.9rem",
                            }}
                            placeholder={t("End Time")}
                            value={endTime}
                            onChange={(e) => {
                              setendTime(e.target.value);
                              setValidation((prevState) => ({
                                ...prevState,
                                endTimeWarning: false,
                                timeDiffWarning: false,
                              }));
                            }}
                          />
                        </div>
                      </div>
                      {(validation.startTimeWarning ||
                        validation.endTimeWarning ||
                        validation.timeDiffWarning) && (
                        <div className="row g-3 mt-1">
                          <div className="col-md-6">
                            {validation.startTimeWarning && (
                              <div
                                className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2"
                                style={{
                                  fontSize: "0.75rem",
                                  margin: "0",
                                  width: "max-content",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{ fontSize: "0.9rem" }}
                                >
                                  warning
                                </span>
                                <span>{t("Please enter start time!")}</span>
                              </div>
                            )}
                          </div>
                          <div className="col-md-6">
                            {validation.endTimeWarning && (
                              <div
                                className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2"
                                style={{ fontSize: "0.75rem", margin: "0" }}
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{ fontSize: "0.9rem" }}
                                >
                                  warning
                                </span>
                                <span>{t("Please enter a end time!")}</span>
                              </div>
                            )}
                            {validation.timeDiffWarning && (
                              <div
                                className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2 mt-1"
                                style={{ fontSize: "0.75rem", margin: "0" }}
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{ fontSize: "0.9rem" }}
                                >
                                  warning
                                </span>
                                <span>
                                  End time should not be less then start time!
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="d-flex align-items-center gap-2 mb-3">
                      <div
                        className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: "35px", height: "35px" }}
                      >
                        <span className="material-symbols-outlined text-white fs-sm">
                          location_on
                        </span>
                      </div>
                      <label
                        htmlFor="location"
                        className="d-block fs-md fw-bold text-dark mb-0"
                      >
                        {t("Location")}
                      </label>
                    </div>
                    <div
                      className="field-container p-4 rounded-15 shadow-sm mb-4 position-relative overflow-hidden"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(248, 249, 250, 1) 100%)",
                        border: "1px solid var(--bs-gray-300)",
                        transition: "all 0.3s ease-in-out",
                      }}
                    >
                      <div className="row g-3 mb-2">
                        <div className="col-md-12">
                          <label className="d-block fs-sm fw-bold text-dark mb-0">
                            <span
                              className="material-symbols-outlined fs-sm me-1"
                              style={{ verticalAlign: "middle" }}
                            >
                              location_on
                            </span>
                            {t("Location")}
                          </label>
                        </div>
                      </div>
                      <div className="row g-3 mb-2">
                        <div className="col-md-12">
                          <input
                            type="text"
                            className="form-control shadow-none border border-gray-300 fw-semibold"
                            style={{
                              borderRadius: "10px",
                              padding: "12px 16px",
                              fontSize: "0.9rem",
                            }}
                            placeholder={t("Enter location")}
                            value={location}
                            onChange={(e) => {
                              setLocation(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`action d-flex align-items-center mt-4 pt-3 border-top border-gray-300 ${
                    selectedAgendaId
                      ? "justify-content-between"
                      : "justify-content-end"
                  }`}
                >
                  {selectedAgendaId ? (
                    <button
                      type="button"
                      className="btn btn-outline-danger p-3 d-inline-flex align-items-center gap-2 rounded-15"
                      onClick={deleteAgendaHandler}
                      style={{
                        transition: "all 0.3s ease-in-out",
                        fontWeight: "600",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.05)";
                        e.currentTarget.style.backgroundColor =
                          "var(--bs-danger)";
                        e.currentTarget.style.color = "white";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color = "var(--bs-danger)";
                      }}
                    >
                      <span className="material-symbols-outlined fs-md">
                        delete
                      </span>
                      <span>{t("Delete Agenda")}</span>
                    </button>
                  ) : null}{" "}
                  <button
                    type="button"
                    className="btn btn-primary p-3 rounded-15 fw-bold d-inline-flex align-items-center gap-2"
                    onClick={saveAgendaHandler}
                    style={{
                      transition: "all 0.3s ease-in-out",
                      fontSize: "1rem",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.05)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 25px rgba(238, 82, 60, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <span className="material-symbols-outlined fs-md">
                      save
                    </span>
                    <span>{t("Save Agenda")}</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveAgendaModal;
